import React from 'react';

type Props = {
	position: 'left' | 'right';
	width: number;
	isVisible: boolean;
};

/**
 * Renders OUTSIDE ShadcnScope in the main DOM.
 * Uses inline styles since it's outside Tailwind scope.
 */
const SnapHotspot = ({ position, width, isVisible }: Props) => {
	if (!isVisible) return null;

	return (
		<div
			style={{
				position: 'fixed',
				zIndex: 10011,
				top: 20,
				bottom: 20,
				width,
				backgroundColor: 'rgba(0,0,0,0.03)',
				pointerEvents: 'none',
				opacity: 0.5,
				...(position === 'left' ? { left: 47 } : { right: 20 })
			}}
		/>
	);
};

export default SnapHotspot;
